import type { VariantProps } from 'class-variance-authority'

import { cva } from 'class-variance-authority'

export const bubbleVariants = cva(
  'group/bubble relative flex w-fit min-w-0 max-w-[80%] flex-col gap-1 data-[variant=ghost]:max-w-full data-[align=end]:self-end group-data-[align=end]/message:self-end',
  {
    variants: {
      variant: {
        default: '[&>[data-slot=bubble-content]:is(button,a):hover]:bg-primary/80 [&>[data-slot=bubble-content]]:bg-primary [&>[data-slot=bubble-content]]:text-primary-foreground',
        secondary: '[&>[data-slot=bubble-content]:is(button,a):hover]:bg-neutral-200 [&>[data-slot=bubble-content]]:bg-secondary [&>[data-slot=bubble-content]]:text-secondary-foreground',
        muted: '[&>[data-slot=bubble-content]:is(button,a):hover]:bg-neutral-200 [&>[data-slot=bubble-content]]:bg-muted',
        tinted: '[&>[data-slot=bubble-content]:is(button,a):hover]:bg-blue-100 [&>[data-slot=bubble-content]]:bg-blue-50 [&>[data-slot=bubble-content]]:text-foreground',
        outline: '[&>[data-slot=bubble-content]:is(button,a):hover]:bg-muted [&>[data-slot=bubble-content]:is(button,a):hover]:text-foreground [&>[data-slot=bubble-content]]:border-border [&>[data-slot=bubble-content]]:bg-background',
        ghost: 'border-none [&>[data-slot=bubble-content]:is(button,a):hover]:bg-muted [&>[data-slot=bubble-content]:is(button,a):hover]:text-foreground [&>[data-slot=bubble-content]]:rounded-none [&>[data-slot=bubble-content]]:bg-transparent [&>[data-slot=bubble-content]]:p-0',
        destructive: '[&>[data-slot=bubble-content]:is(button,a):hover]:bg-destructive/20 [&>[data-slot=bubble-content]]:bg-destructive/10 [&>[data-slot=bubble-content]]:text-destructive',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
)

export type BubbleVariants = VariantProps<typeof bubbleVariants>

export const bubbleReactionsVariants = cva(
  'absolute z-10 flex w-fit shrink-0 items-center justify-center gap-1 rounded-full bg-muted px-1.5 py-0.5 text-sm ring ring-card has-[button]:p-0',
  {
    variants: {
      side: {
        top: 'top-0 -translate-y-3/4',
        bottom: 'bottom-0 translate-y-3/4',
      },
      align: {
        start: 'left-3',
        end: 'right-3',
      },
    },
    defaultVariants: {
      side: 'bottom',
      align: 'end',
    },
  },
)
export type BubbleReactionsVariants = VariantProps<typeof bubbleReactionsVariants>
